import React, { CSSProperties } from 'react';

interface SeparatorIconProps {
    fill?: string;
    stroke?: string;
    width?: string;
    height?: string;
    style?: CSSProperties;
    className?: string;
}

const SeparatorIcon: React.FC<SeparatorIconProps> = ({
    stroke = 'currentColor',
    width = '100%',
    height = '100%',
    style,
    className
}) => {
    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={style}
        >
            <path
                d="M5 12H19"
                stroke={stroke}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default SeparatorIcon;
